import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const CaretRightThickIcon = (props: IconProps) => (
  <IconBase viewBox="0 0 7 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.46967 0.21967C0.762563 -0.0732233 1.23744 -0.0732233 1.53033 0.21967L6.78033 5.46967C7.07322 5.76256 7.07322 6.23744 6.78033 6.53033L1.53033 11.7803C1.23744 12.0732 0.762563 12.0732 0.46967 11.7803C0.176777 11.4874 0.176777 11.0126 0.46967 10.7197L5.18934 6L0.46967 1.28033C0.176777 0.987437 0.176777 0.512563 0.46967 0.21967Z"
      fill="CurrentColor"
    />
  </IconBase>
);
